export type OtpJourneyEntryPoint = "checkout" | "auth";
export type OtpJourneyRuntime = "production" | "non_production";

export interface OtpJourneyMetadata {
  otp_journey_id: string;
  otp_entry_point: OtpJourneyEntryPoint;
  runtime_classification: OtpJourneyRuntime;
  deployment_classification: "production" | "development" | "test";
}

function createOpaqueJourneyId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
    crypto.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}

export function otpJourneyEntryPoint(next?: string): OtpJourneyEntryPoint {
  return typeof next === "string" && /^\/(?:[a-z]{2}\/){0,2}checkout(?:[/?#]|$)/i.test(next)
    ? "checkout"
    : "auth";
}

export function createOtpJourneyMetadata(next?: string): OtpJourneyMetadata {
  const production = import.meta.env.PROD === true;
  const mode = String(import.meta.env.MODE || "").toLowerCase();
  return {
    otp_journey_id: createOpaqueJourneyId(),
    otp_entry_point: otpJourneyEntryPoint(next),
    runtime_classification: production ? "production" : "non_production",
    deployment_classification: production ? "production" : mode === "test" ? "test" : "development",
  };
}